export default __webpack_public_path__ + "static/media/dinheiro_queroumaagencia.42e82f50.png";